import { PageButton, Wrapper } from './atoms'
import { LeftArrow } from './svg/left-arrow'
import { RightArrow } from './svg/right-arrow'
import { usePagination } from './use-pagination'

interface Props {
  total: number
  pageSize: number
  pageNum: number
  onChange: (value: number) => void
  siblingCount?: number
}

export const Pagination = ({ total, pageSize, pageNum, onChange, siblingCount = 1 }: Props) => {
  const { itemList } = usePagination({ total, pageNum, pageSize, siblingCount })

  return (
    <Wrapper>
      <PageButton $disabled={pageNum <= 1} onClick={() => pageNum > 1 && onChange(pageNum - 1)}>
        <LeftArrow />
      </PageButton>
      {itemList.map((item) => (
        <PageButton
          key={item}
          $isActive={pageNum === item}
          onClick={() => typeof item === 'number' && onChange(item)}
          $isEllipsis={item === 'ellipsis'}
        >
          {item === 'ellipsis' ? '...' : item}
        </PageButton>
      ))}
      <PageButton
        $disabled={pageNum >= (itemList[itemList.length - 1] as number)}
        $noMarginRight
        onClick={() => pageNum < (itemList[itemList.length - 1] as number) && onChange(pageNum + 1)}
      >
        <RightArrow />
      </PageButton>
    </Wrapper>
  )
}
